import { z } from 'zod';

export const orderTrackSchema = z.object({
  orderNumber: z.string().regex(/^\d+$/, 'Invalid Order Id'),
  email: z.string().email(),
});
